module.exports = __webpack_public_path__ + "img/Ellipse-7.203cee07.png";